'use strict';

var react = require('react');

const useOverflowScrollPosition = ({ shouldRenderMask })=>{
    const [overflowMaskPosition, setOverflowMaskPosition] = react.useState('none');
    // On first open, we check if the overflow mask needs to be rendered
    react.useEffect(()=>{
        // if we have more than maxMenuItems, we render the overflow mask
        setOverflowMaskPosition(shouldRenderMask ? 'bottom' : 'none');
    }, [
        shouldRenderMask
    ]);
    /**
     * Handle overflow mask on drop down scroll.
     *
     * Depending on the scroll position we set the position of the
     * overflow mask that's rendered within the scroll container.
     */ const onScroll = react.useCallback((e)=>{
        const atTop = e.currentTarget.scrollTop <= 0;
        const atBottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        if (!atTop && !atBottom) {
            setOverflowMaskPosition('both');
        } else if (atTop) {
            setOverflowMaskPosition('bottom');
        } else if (atBottom) {
            setOverflowMaskPosition('top');
        }
    }, []);
    return {
        overflowMaskPosition,
        onScroll
    };
};

exports.useOverflowScrollPosition = useOverflowScrollPosition;
//# sourceMappingURL=useOverflowScrollPosition.js.map
